import { Avatar, Button, Dropdown, Space, theme } from 'antd'
import React, { useState } from 'react'
import { UserOutlined, AntDesignOutlined } from '@ant-design/icons'
import useAuthRepo from 'services/repo/useAuthRepo'
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks'
import { toggleSideMenu } from 'utils/Helper'
import { Link } from 'react-router-dom'
import { useAtom } from 'jotai'
import { userAtom } from 'store/Auth/authAtom'
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant'
import BurgerMenu from 'assets/img/BurgerMenu'
import LocalStorageUtils from 'utils/LocalStorage'
import { capitalizeWords } from 'utils/Helper';
import TaskCount from 'components/Dashboard/TaskCount';
export default function Topbar() {
  const { isLoading: isLoadingLogout, logout } = useAuthRepo(false)
  const { topbarTitle } = useTopbarTitleHooks()
  const [user, setUser] = useAtom(userAtom)
  const { token } = theme.useToken()
  const [isOpen, setIsOpen] = useState(false)
  const userInfo = LocalStorageUtils.userInfo.get()

  const contentStyle = {
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
  }

  return (
    <section
      className='eproc-topbar'
      style={{
        display: 'flex',  
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 16px',
        height: 60,
        background: '#fff',
      }}
    >
      {/* KIRI: burger + title */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div className='wrapper-burger' onClick={toggleSideMenu}>
          <BurgerMenu />
        </div>
        <div style={{ fontWeight: 600 }}>{topbarTitle}</div>
      </div>

      {/* KANAN: nama user + avatar + dropdown */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
         <div
                style={{
                    position: 'sticky',
                    top: 1,                // offset dari atas viewport
                    zIndex: 1,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '50%'
                }}
            >
                <TaskCount />
            </div>
        <span
          style={{
            fontWeight: 500,
            fontSize: 14,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 250,
          }}
        >
            {capitalizeWords(userInfo.userFullName) }<br/>
            {/* {userInfo.roleId} */}
        </span>

        <Dropdown
          overlayClassName='dropdown-top-bar-user'
          placement='bottomLeft'
          trigger={['hover']}
          dropdownRender={() => (
            <div style={contentStyle} className='dropdown-content'>
              <div className='wrap-avatar'>
                <Space wrap size={16}>
                  <Avatar size={70} icon={<AntDesignOutlined />} src={user?.photoBlob} />
                </Space>
              </div>
              <p className='username'>{userInfo.userFullName } </p>

              <Link to={APP_ROUTE_PREFIX + '/' + RouteConstant.myProfile}>View Profile</Link>
              <Button
                type='dashed'
                danger
                onClick={logout}
                disabled={isLoadingLogout}
                loading={isLoadingLogout}
              >
                Logout
              </Button>
            </div>
          )}
        >
          <div>
            <Avatar
              shape='square'
              icon={<UserOutlined />}
              src={user?.photoBlob}
              onClick={() => setIsOpen(!isOpen)}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </Dropdown>
      </div>
    </section>
  )
}
